import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import template from './NewInstallationGroupItem.rt';
import * as actions from './NewInstallationGroupItemActions';

const MapStateToProps = (state) => {
  return {};
}

const MapDispatchToProps = (dispatch, props) => {
  return {
    showNewGroupItem: () => dispatch(actions.showNewInstallationGroupItemOverlay(props.group))
  };
}

class NewInstallationGroupItemClass extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      overlayVisible: false
    };
  };

  render = template;
}

const connector = connect(MapStateToProps, MapDispatchToProps);
const NewInstallationGroupItem = connector(NewInstallationGroupItemClass);

export { NewInstallationGroupItem };
export default NewInstallationGroupItem;

